/** @format */

export const api_address = "https://game.detechtiv.se";
// export const api_address = "https://detechtivhunt.cogheart.se";
// export const api_address = "http://localhost:3030";

// get
export const GET = async (endpoint) => {
  return await fetch(api_address + endpoint, {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  }).then((res) => res.json());
};

// post
export const POST = async (endpoint, data, auth) => {
  return await fetch(api_address + endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      auth: auth,
    },
    body: JSON.stringify(data),
  }).then((res) => res.json());
};
